import {
  Group,
  OptionDescription,
  OptionLabel,
  OptionLabelText,
  RadioInput,
  TextBlock,
} from './DepositPaymentPicker.styles';
import type { DepositPaymentPickerProps } from './DepositPaymentPicker.types';

const DEFAULT_LABELS = {
  groupAriaLabel: 'Payment options',
};

export function DepositPaymentPicker({
  name = 'depositPaymentOption',
  options,
  value,
  onChange,
  labels,
}: DepositPaymentPickerProps) {
  const merged = { ...DEFAULT_LABELS, ...labels };

  return (
    <Group role="radiogroup" aria-label={merged.groupAriaLabel}>
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <OptionLabel
            key={option.value}
            data-selected={selected}
            data-disabled={option.disabled || undefined}
          >
            <TextBlock>
              <OptionLabelText>{option.label}</OptionLabelText>
              {option.description && <OptionDescription>{option.description}</OptionDescription>}
            </TextBlock>
            <RadioInput
              type="radio"
              name={name}
              value={option.value}
              checked={selected}
              disabled={option.disabled}
              onChange={() => {
                if (option.disabled) return;
                onChange(option.value);
              }}
              aria-label={option.label}
            />
          </OptionLabel>
        );
      })}
    </Group>
  );
}
